// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
}

.home-first {
  height: calc(100vh - 128px);
}

.home {
  padding-top: 64px;
  padding-bottom: 64px;
  overflow-y: hidden;
  width: 100%;
  overflow-x: hidden;
  position: relative; /* for z-index shenanigans */
  z-index: 3;
}

.top-back {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  height: 1080px;
  background-size: cover;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #E9F1F8;
  background-image: url('head_w.svg');
}

.title-container {
  padding: 0px 3em;
  text-align: center;
  display: block;
  letter-spacing: 1px;
  padding-top: 24px;
}

.img-parent {
  width: 100%;
}

.grid-3-4 {
  display: grid;
  grid-template-areas: "img" "descr" "metrics";
  gap: 64px;
  justify-content: center;
}

.grid-3-4-img {
  grid-area: img;
}

.grid-3-4-descr {
  grid-area: descr;
}

.grid-3-4-metrics {
  grid-area: metrics;
}

.grid3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  align-items: baseline;
  justify-items: start;
  justify-content: space-between;
}

.tab {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: 60vh;
}

.tab-slide {
  animation: slide-in-small 3s forwards;
}

@keyframes slide-in {
  0% {
    transform: translateX(-50vw);
  }
  100% {
    transform: translateX(13vw);
  }
}
@keyframes slide-in-small {
  0% {
    transform: translateX(-50vw);
  }
  100% {
    transform: translateX(0vw);
  }
}
.pd-b {
  padding-top: 40px;
  height: initial;
}

.m-8 {
  max-width: 95%;
}

.img-cloud-container {
  display: grid;
  justify-content: center;
}

.ml {
  width: 400px;
}

.lp-b {
  background-color: #009cd2;
  color: #fff;
}
.lp-b h1, .lp-b h2, .lp-b h3, .lp-b h4 {
  color: #fff;
}

.down {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px; /* the down arrow is 44px */
  display: grid;
  justify-content: center;
}

.down-img {
  width: 80px;
  height: 44px;
}

.down-c .c1 {
  animation: down 6s infinite ease-out normal;
}

@keyframes down {
  0% {
    opacity: 0.05;
  }
  25% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.05;
  }
}
.pointer {
  cursor: pointer;
}

.pointer:hover {
  opacity: 1 !important;
  animation: none;
}

.lp-img-cloud {
  width: 100%;
}

.metric {
  width: 150px;
  text-align: center;
}

.nr {
  font-size: 42px;
  text-align: center;
}

.sub {
  font-size: 18px;
  width: 100%;
}

.ctr {
  text-align: center;
}

.a1 {
  height: 135px;
}

.t {
  height: 87px;
}

.references {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  justify-items: center;
  align-items: center;
  row-gap: 2rem;
}

@media screen and (min-width: 769px) {
  .m-8 {
    max-width: 80% !important;
  }
  .pd-b {
    padding-top: 100px;
    height: 500px;
  }
  .grid-3-4 {
    grid-template-columns: minmax(400px, 30vw) minmax(min-content, 600px);
    grid-template-areas: "img descr" "metrics metrics";
  }
}
@media screen and (min-width: 1025px) {
  .tab-slide {
    animation-name: slide-in;
  }
}
@media screen and (min-width: 1281px) {
  .grid-3-4 {
    grid-template-columns: minmax(400px, 30vw) minmax(min-content, 600px);
    grid-template-areas: "img descr" "img metrics";
  }
}`, "",{"version":3,"sources":["webpack://./src/app/page/company/company.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAGA;EACI,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA,EAAA,4BAAA;EACA,UAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kCAAA;EACA,yBAAA;EAEA,mCAAA;AADJ;;AAIA;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EAEA,mBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,4CACI;EAGJ,SAAA;EACA,uBAAA;AALJ;;AAOA;EAAgB,cAAA;AAHhB;;AAIA;EAAkB,gBAAA;AAAlB;;AACA;EAAoB,kBAAA;AAGpB;;AADA;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,qBAAA;EACA,oBAAA;EACA,8BAAA;AAIJ;;AADA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAIJ;;AADA;EACI,qCAAA;AAIJ;;AADA;EACI;IAAK,4BAAA;EAKP;EAJE;IAAO,2BAAA;EAOT;AACF;AALA;EACI;IAAK,4BAAA;EAQP;EAPE;IAAO,0BAAA;EAUT;AACF;AARA;EACI,iBAAA;EACA,eAAA;AAUJ;;AAPA;EACI,cAAA;AAUJ;;AAPA;EACI,aAAA;EACA,uBAAA;AAUJ;;AAPA;EACI,YAAA;AAUJ;;AAPA;EACI,yBAAA;EAEA,WAAA;AASJ;AAPI;EACI,WAAA;AASR;;AALA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA,EAAA,2BAAA;EACA,aAAA;EACA,uBAAA;AAQJ;;AALA;EACI,WAAA;EACA,YAAA;AAQJ;;AALA;EACI,2CAAA;AAQJ;;AALA;EACI;IACI,aAAA;EAQN;EALE;IACI,YAAA;EAON;EAJE;IACI,aAAA;EAMN;AACF;AAHA;EACI,eAAA;AAKJ;;AAFA;EACI,qBAAA;EACA,eAAA;AAKJ;;AAFA;EACI,WAAA;AAKJ;;AAFA;EACI,YAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,WAAA;AAKJ;;AAFA;EACI,kBAAA;AAKJ;;AAFA;EACI,aAAA;AAKJ;;AAFA;EACI,YAAA;AAKJ;;AAFA;EACI,aAAA;EACA,2DAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AAKJ;;AAFA;EACI;IACI,yBAAA;EAKN;EAFE;IACI,kBAAA;IACA,aAAA;EAIN;EADE;IACI,qEAAA;IACA,kDACI;EAEV;AACF;AAGA;EACI;IACI,wBAAA;EADN;AACF;AAIA;EACI;IACI,qEAAA;IACA,8CACI;EAHV;AACF","sourcesContent":[":host {\n    width: 100%;\n    height: 100%;\n}\n\n.home-first {\n    height: calc(100vh - 128px);\n}\n\n\n.home {\n    padding-top: 64px;\n    padding-bottom: 64px;\n    overflow-y: hidden;\n    width: 100%;\n    overflow-x: hidden;\n    position: relative; /* for z-index shenanigans */\n    z-index: 3;\n}\n\n.top-back {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n    width: 100%;\n    height: 1080px;\n    background-size: cover;\n    overflow: hidden;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-color: #E9F1F8;\n\n    background-image: url('../../../assets/head_w.svg');\n}\n\n.title-container {\n    padding: 0px 3em;\n    text-align: center;\n    display: block;\n\n    letter-spacing: 1px;\n    padding-top: 24px;\n}\n\n.img-parent {\n    width: 100%;\n}\n\n.grid-3-4 {\n    display: grid;\n    grid-template-areas: \n        \"img\"\n        \"descr\"\n        \"metrics\";\n    gap: 64px;\n    justify-content: center;\n}\n.grid-3-4-img { grid-area: img };\n.grid-3-4-descr { grid-area: descr };\n.grid-3-4-metrics { grid-area: metrics };\n\n.grid3 {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 16px;\n    align-items: baseline;\n    justify-items: start;\n    justify-content: space-between;\n}\n\n.tab {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 100%;\n    max-height: 60vh;\n}\n\n.tab-slide {\n    animation: slide-in-small 3s forwards;\n}\n\n@keyframes slide-in {\n    0% { transform: translateX(-50vw); }\n    100% { transform: translateX(13vw); };\n}\n\n@keyframes slide-in-small {\n    0% { transform: translateX(-50vw); }\n    100% { transform: translateX(0vw); };\n}\n\n.pd-b {\n    padding-top: 40px;\n    height: initial;\n}\n\n.m-8 {\n    max-width: 95%;\n}\n\n.img-cloud-container {\n    display: grid;\n    justify-content: center;\n}\n\n.ml {\n    width: 400px;\n}\n\n.lp-b {\n    background-color: #009cd2;\n\n    color: #fff;\n\n    h1, h2, h3, h4 {\n        color: #fff;\n    }\n}\n\n.down {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: calc(44px + 16px); /* the down arrow is 44px */\n    display:grid;\n    justify-content: center;\n}\n\n.down-img {\n    width: 80px;\n    height: 44px;\n}\n\n.down-c .c1 {\n    animation: down 6s infinite ease-out normal;\n}\n\n@keyframes down {\n    0% {\n        opacity: 0.05;\n    }\n\n    25% {\n        opacity: 0.6;\n    }\n\n    100% {\n        opacity: 0.05;\n    }\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.pointer:hover {\n    opacity: 1 !important;\n    animation: none;\n}\n\n.lp-img-cloud {\n    width: 100%;\n}\n\n.metric {\n    width: 150px;\n    text-align: center;\n}\n\n.nr  {\n    font-size: 42px;\n    text-align: center;\n}\n\n.sub {\n    font-size: 18px;\n    width: 100%;\n}\n\n.ctr {\n    text-align: center;\n}\n\n.a1 {\n    height: 135px;\n}\n\n.t {\n    height: 87px;\n}\n\n.references {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    justify-items: center;\n    align-items: center;\n    row-gap: 2rem;\n}\n\n@media screen and (min-width: 769px) {\n    .m-8 {\n        max-width: 80% !important;\n    }\n\n    .pd-b {\n        padding-top: 100px;\n        height: 500px;\n    }\n\n    .grid-3-4 {\n        grid-template-columns: minmax(400px, 30vw) minmax(min-content, 600px);\n        grid-template-areas:\n            \"img descr\"\n            \"metrics metrics\";\n\n    }\n}\n\n@media screen and (min-width: 1025px) {\n    .tab-slide {\n        animation-name: slide-in;\n    }\n}\n\n@media screen and (min-width: 1281px) {\n    .grid-3-4 {\n        grid-template-columns: minmax(400px, 30vw) minmax(min-content, 600px);\n        grid-template-areas: \n            \"img descr\"\n            \"img metrics\";\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
